import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initBotId } from 'botid/client/core'
import { AuthProvider } from './context/AuthContext.tsx'
import { ThemeProvider } from './context/ThemeContext.tsx'
import App from './App.tsx'
import './index.css'
import '@flaticon/flaticon-uicons/css/all/all.css'

// Vercel BotID: tag the signup entry endpoint so the client adds the
// challenge headers on POST to /api/send-verification-code. The Vercel
// function on that path calls checkBotId() and 403s suspected bots
// before any request reaches Supabase. Adding new protected paths
// requires both this entry AND a matching Vercel function.
initBotId({
  protect: [
    { path: '/api/send-verification-code', method: 'POST' },
  ],
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
)